/* Judge.me reviews: first and last page buttons.
   Copied unchanged from sections/product-template.liquid, which is switched off on the bed and mattress pages.
   Styles: .mj-pagination-edge in assets/product-template.css. */
// Judge.me review pagination: first / last page buttons.
// The revamp widget only renders prev / next; the old widget also had |< and >|.
// Each added button clicks Judge.me's own page-1 / last-page button, so the widget
// still does the paging. Vue re-renders the controls, hence the observer.
(function () {
  function init() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget || !('MutationObserver' in window)) return;

    var chevron = {
      first: 'M6.454 5.99976L10.5271 10.0728C10.8150 10.3607 10.8150 10.8389 10.5271 11.1268C10.2392 11.4147 9.7610 11.4147 9.4731 11.1268L4.9789 6.63251C4.6290 6.28263 4.6290 5.71689 4.9789 5.36701L9.4731 0.872758C9.7610 0.584858 10.2392 0.584858 10.5271 0.872758C10.8150 1.16066 10.8150 1.63886 10.5271 1.92676L6.454 5.99976Z',
      last: 'M4.94626 6.00001L0.873012 1.92701C0.585112 1.63911 0.585112 1.16091 0.873012 0.873012C1.16091 0.585112 1.63911 0.585112 1.92701 0.873012L6.42126 5.36726C6.77114 5.71714 6.77114 6.28288 6.42126 6.63276L1.92701 11.127C1.63911 11.4149 1.16091 11.4149 0.873012 11.127C0.585112 10.8391 0.585112 10.3609 0.873012 10.073L4.94626 6.00001Z'
    };
    var bar = { first: 'M0.7 1.4a.75.75 0 0 1 1.5 0v9.2a.75.75 0 0 1-1.5 0z', last: 'M8.8 1.4a.75.75 0 0 1 1.5 0v9.2a.75.75 0 0 1-1.5 0z' };

    function pages() {
      return widget.querySelectorAll('.jm-pagination-controls__button--page');
    }

    function makeButton(which) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jm-button jm-pagination-controls__button jm-pagination-controls__button--nav mj-pagination-edge mj-pagination-edge--' + which;
      btn.setAttribute('aria-label', which === 'first' ? 'Go to first page' : 'Go to last page');
      btn.innerHTML = '<svg width="11" height="12" viewBox="0 0 11 12" fill="currentColor" aria-hidden="true" focusable="false">' +
        '<path d="' + bar[which] + '"/><path d="' + chevron[which] + '"/></svg>';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var list = pages();
        var target = which === 'first' ? list[0] : list[list.length - 1];
        if (target) target.click();
      });
      return btn;
    }

    function setDisabled(btn, disabled) {
      if (btn.disabled !== disabled) btn.disabled = disabled;
      if (btn.classList.contains('jm-button--disabled') !== disabled) btn.classList.toggle('jm-button--disabled', disabled);
    }

    function sync() {
      var nav = widget.querySelector('.jm-pagination-controls');
      var list = pages();
      if (!nav || !list.length) return;
      var active = nav.querySelector('.jm-pagination-controls__button--active');
      var first = nav.querySelector('.mj-pagination-edge--first');
      var last = nav.querySelector('.mj-pagination-edge--last');
      if (!first) {
        first = makeButton('first');
        nav.insertBefore(first, nav.firstChild);
      }
      if (!last) {
        last = makeButton('last');
        nav.appendChild(last);
      }
      setDisabled(first, !active || active === list[0]);
      setDisabled(last, !active || active === list[list.length - 1]);
    }

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        sync();
      });
    }).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
